import { axios } from '@/utils/request'

export function getRiskConversionReport(params) {
  return axios({
    url: '/riskReport/conversionList',
    method: 'get',
    params
  })
}

export function getAppRiskReport(params) {
  return axios({
    url: '/webpublic/riskReport/appRiskList',
    method: 'get',
    params
  })
}
